import React from 'react'
import Essence from './Component/Essence'

const EssencePage = () => {
  return (
    <div>
      <Essence />
    </div>
  )
}

export default EssencePage